import BaseProxyAcquisition from "@/proxies/base-proxy-acquisition";
import { LocalStoreManager as LocalStore } from "@sleek/customer-common-acquisition";

/**
 * @class GetUsersMeProxy
 * @description Class used for communicating GET requests with user API.
 * @author Koh Keng Hong
 * @version 1.0
 * @since November 29, 2018
 */
export default class GetUsersMeProxy {
  /**
   * @async
   * @function execute
   */
  async execute(authToken = "") {
    let baseProxy = new BaseProxyAcquisition();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/users/me`;

    if (!authToken) {
      let localStore = new LocalStore();
      authToken = localStore.getToken();
    }

    return await baseProxy.getAuthenticatedData(endpointUrl, authToken);
  }

  async getWithoutAuthCheck(authToken = "") {
    try {
      const baseProxy = new BaseProxyAcquisition();
      const backendUrl = await baseProxy.getBackendUrl();
      const endpointUrl = `${backendUrl}/users/me`;
      if (!authToken) {
        let localStore = new LocalStore();
        authToken = localStore.getToken();
      }
      return await baseProxy.getUnauthenticatedData(endpointUrl, { authToken });
    } catch (error) {
      console.log(error);
      return null;
    }
  }
}
